import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { AuthServerProvider } from '@fitup-monorepo/core/lib/services/auth/auth-jwt.service';
import { AppRoutes } from '@fitup-monorepo/routes/lib/app-routes';

export const pinboardGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authServerProvider = inject(AuthServerProvider);
  const router = inject(Router);

  if (!(await authServerProvider.isAuthenticated())) {
    return true;
  }

  const publicPinboardId = route.params['publicPinboardId'];
  const prefix = `/partner/${publicPinboardId}`;
  const subPath = state.url.startsWith(prefix) ? state.url.slice(prefix.length) : '';

  const categoryMatch = subPath.match(/^\/category\/([^/?]+)/);
  if (categoryMatch) {
    return router.parseUrl(`${AppRoutes.TABS_NOTIFICATIONS_ALL}?category=${categoryMatch[1]}`);
  }

  return router.parseUrl(subPath ? `${AppRoutes.TABS_NOTIFICATIONS}${subPath}` : `${AppRoutes.TABS_NOTIFICATIONS_ALL}`);
};
